import { Component, Input, OnInit } from '@angular/core';
import { VisaoLeadsServiceService } from '../visao-leads-service/visao-leads.service';
import { LeadInsucesso, LeadSummary } from '../interfaces/lead-summary';

@Component({
  selector: 'app-resumo-leads',
  templateUrl: './resumo-leads.component.html',
  styleUrls: ['./resumo-leads.component.css']
})
export class ResumoLeadsComponent implements OnInit {

  @Input() leadData!: LeadSummary;
  @Input() insucessoLeads!: LeadInsucesso;
  @Input() totalInsucesso!: number;

  constructor() { }

  ngOnInit() {
  }


  
}
